export default "__VITE_ASSET__cFGFZD4Z__"